import Head from "next/head";
import { PureComponent } from "react";
import Topbar from "/components/core/top-bar-new/top-bar-component";
import Footer from "/components/core/footer-new/footer-component";
import { MAIN_ID } from "constants/element-ids";

import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";

import BaseTemplate from "../base-template";
import SegmentsListComponent from "/components/segments/segments-list/segments-list-component";
import {
  LOGO_THEME_LIGHT_COLOR,
  LOGO_THEME_BLACK_COLOR,
  LOGO_THEME_BLACK,
  LOGO_THEME_LIGHT
} from "/constants/logo-themes";

export default class LongTemplate extends PureComponent {
  render() {
    let { headerUrl, exitPopup, stickyMode, pageConfig, isPreview } = this.props;

    const { segments, topbar, footer, socialButtons, topBanner, exitPopupConfig } = pageConfig;
    const preventMenu = topbar && topbar.preventMenu;
    const preventFooter = footer && footer.preventFooter;

    return (
      <BaseTemplate {...this.props} {...pageConfig}>
        <Topbar
          url={headerUrl}
          loginTheme={pageConfig.loginTheme}
          menuTheme={pageConfig.menuTheme}
          logoTheme={LOGO_THEME_LIGHT_COLOR}
          showMenu={!preventMenu}
          stickyMode={stickyMode}
          allowSocialButtons={socialButtons && socialButtons.show}
          socialButtonsColor={socialButtons && socialButtons.color}
          socialButtonBlogStyle={socialButtons && socialButtons.blogStyle}
          topBanner={topBanner}
          maxWidth="100%"
          headerBackgroundColor="white"
        />
        <main id={MAIN_ID}>
          <SegmentsListComponent segments={segments} isPreview={isPreview} />
        </main>

        {!preventFooter && (
          <Footer nameSignature={pageConfig.nameSignature} showTrustpilotReviews={pageConfig.showTrustpilotReviews} />
        )}
        <CoreAddonsComponent exitPopup={exitPopup} exitPopupConfig={exitPopupConfig} />
      </BaseTemplate>
    );
  }
}

LongTemplate.defaultProps = {
  headerUrl: "https://monday.com/",
  title: "monday.com",
  description: "",
  exitPopup: true,
  menuTheme: "",
  loginTheme: ""
};
